import { render, staticRenderFns } from "./RoleAuthority.vue?vue&type=template&id=3b0a83cc"
import script from "./RoleAuthority.vue?vue&type=script&lang=js"
export * from "./RoleAuthority.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports